import Modal from '@mui/material/Modal';
import React from 'react';
import { withRouter } from 'react-router';
import { Route } from 'react-router-dom';
import * as globalStyles from '../../../utils/GlobalStyles';
import MaskView from '../MaskView';

function ModalView(props) {
  const {
    children,
    modalPath,
    exitRoute,
    history,
    isOpen,
    onRendered, // Modal onRendered prop removed from MUI5. Kept this name as it makes more sense
    onClose,
    isLoading,
    contentContainerStyle = {},
    isMobile,
  } = props;

  const dynamicContentContainerStyle = {
    ...(isMobile ? styles.mobileContent : styles.content),
    ...contentContainerStyle,
  };

  function getModal(isModalOpen, onCloseModal) {
    return (
      <Modal open={isModalOpen} onClose={onCloseModal} style={styles.modal} ref={onRendered}>
        <div style={dynamicContentContainerStyle} className="ModalView">
          <MaskView isLoading={isLoading}>{children}</MaskView>
        </div>
      </Modal>
    );
  }

  if (onClose) {
    return getModal(isOpen, onClose);
  } else {
    return <Route path={modalPath} render={() => getModal(true, () => history.push(exitRoute))} />;
  }
}

const styles = {
  content: {
    maxWidth: '98%',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: 6,
    overflow: 'hidden',
    background: globalStyles.colors.gray2,
    boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.2)',
  },
  mobileContent: {
    display: 'flex',
    position: 'absolute',
    top: '30%',
    margin: '20px',
    borderRadius: 6,
    background: globalStyles.colors.gray2,
    boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.2)',
  },
};

export default withRouter(ModalView);
